/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wd_AboutInputs */

const en_wd_about = /** @type {(inputs: Wd_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About`)
};

const ar_wd_about = /** @type {(inputs: Wd_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عن المشروع`)
};

const bn_wd_about = /** @type {(inputs: Wd_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সম্পর্কে`)
};

const de_wd_about = /** @type {(inputs: Wd_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ungefähr`)
};

const es_wd_about = /** @type {(inputs: Wd_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acerca de`)
};

const fr_wd_about = /** @type {(inputs: Wd_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À propos`)
};

const pt_wd_about = /** @type {(inputs: Wd_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobre`)
};

const zh_wd_about = /** @type {(inputs: Wd_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关于`)
};

const tr_wd_about = /** @type {(inputs: Wd_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakkında`)
};

const ru_wd_about = /** @type {(inputs: Wd_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`О нас`)
};

const pl_wd_about = /** @type {(inputs: Wd_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informacje`)
};

/**
* | output |
* | --- |
* | "About" |
*
* @param {Wd_AboutInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const wd_about = /** @type {((inputs?: Wd_AboutInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wd_AboutInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_wd_about(inputs)
	if (locale === "bn") return bn_wd_about(inputs)
	if (locale === "de") return de_wd_about(inputs)
	if (locale === "es") return es_wd_about(inputs)
	if (locale === "fr") return fr_wd_about(inputs)
	if (locale === "pt") return pt_wd_about(inputs)
	if (locale === "zh") return zh_wd_about(inputs)
	if (locale === "tr") return tr_wd_about(inputs)
	if (locale === "ru") return ru_wd_about(inputs)
	if (locale === "pl") return pl_wd_about(inputs)
	return en_wd_about(inputs)
});